<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="12" xl="12" class="mt-4">
                  <audio-recorder
                    upload-url=""
                    :attempts="3"
                    :time="15"
                    :headers="headers"
                    :show-upload-button="false"
                    :mic-failed="micFailed"
                    :pause-recording="pauseRecord"
                    :after-recording="afterRecord"
                    :select-record="selectRecord"
                    :before-upload="beforeUpload"
                    :remove="removeRecord"/>
                </CCol>
              </CRow>
            </CForm>
            <CButton v-if="isShowBtnFileAdd" color="primary" class="btn-action-primary mt-3"
                     @click="isShowFileAdd = true"><i
              class="fa fa-file"></i> Biên tập
            </CButton>
          </CCardBody>
        </CCard>
        <BaseAudioAddFile v-if="isShowFileAdd" :file="fileAddContent" :duration="durationFileAdd"
                          :sourceType="sourceType"
                          @loading="loadingAdd($event)"></BaseAudioAddFile>
      </CCol>
    </CRow>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import AudioRecorder from '../../../../public/static/js/vue-audio-recorder.min';
import Vue from 'vue'
import BaseAudioAddFile from "@/views/base/AudioAddFile";
import {sourceType} from "@/constant";

Vue.use(AudioRecorder)

export default {
  name: "Record",
  components: {BaseSelect, BaseInput, BaseLoading, BaseAudioAddFile},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      sourceType: sourceType.GHI_AM_TEP_TIN,
      fileAddContent: {
        fileName: '',
        content: ''
      },
      durationFileAdd: '',
      isShowFileAdd: false,
      isShowBtnFileAdd: false,
      headers: {},
      titleInput: {
        options: {
          label: "Tên tệp tin <span class='required'>*</span>",
          placeholder: "Tên tệp tin",
          type: "text"
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên tệp tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      audioRecords: new Map(),
    };
  },
  methods: {
    micFailed: function () {
      this.showErrorMsg({message: 'Vui lòng cho phép truy cập micro và thử lại.'});
    },
    pauseRecord: function (data) {
    },
    async afterRecord(data) {
      let response = {...data};
      response.base64 = await this.$helper.blobToBase64(data.blob);
      this.audioRecords.set(data.id, response);
    },
    removeRecord(data) {
      if (this.audioRecords.has(data.id)) {
        this.isShowBtnFileAdd = false;
        this.isShowFileAdd = false;
        this.audioRecords.delete(data.id);
      }
    },
    selectRecord(data) {
      if (this.audioRecords.has(data.id)) {
        let record = this.audioRecords.get(data.id);
        if (record) {
          this.isShowBtnFileAdd = true;
          this.fileAddContent.fileName = 'Ghi_am_' + record.id + '.mp3';
          this.fileAddContent.content = record.base64;
          this.durationFileAdd = "00:" + record.duration;
        }
      }
    },
    beforeUpload(data) {
    },
    async downloadByUrl() {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = this.fileCutResult.path;
      a.download = this.fileCutResult.fileName;
      a.click();
    },
    submitData: function () {
    },
    loadingAdd(value) {
      if (value) {
        this.loading.value = true;
      } else {
        this.loading.value = false;
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {}
};
</script>
<style>
.ar-icon {
  padding: 0 !important;
}

.ar__rm {
  font-size: 20px !important;
  top: -3px !important;
}

.ar-recorder__duration {
  margin-top: 25px !important;
}

.ar-player__time {
  width: unset !important;
}

.ar-volume {
  margin-left: 10px !important;
}
</style>
